import { createContext, useCallback, useContext, useState } from "react";
import type { ReactNode } from "react";
import { ComposeSheet } from "./ComposeSheet";
import type { ComposePrefill } from "./ComposeSheet";

type Ctx = {
  openCompose: (prefill?: ComposePrefill) => void;
};

const ComposeCtx = createContext<Ctx>({ openCompose: () => null });

export function ComposeProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState<ComposePrefill | undefined>(undefined);

  const openCompose = useCallback((p?: ComposePrefill) => {
    setPrefill(p);
    setOpen(true);
  }, []);

  return (
    <ComposeCtx.Provider value={{ openCompose }}>
      {children}
      <ComposeSheet
        open={open}
        onClose={() => setOpen(false)}
        prefill={prefill}
      />
    </ComposeCtx.Provider>
  );
}

export function useCompose(): Ctx {
  return useContext(ComposeCtx);
}
